import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, from, max } from "rxjs";
import { LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID } from "src/app/conf/user";
import { NotificationMaintenance } from "src/app/model/notification-maintenance";
import { AppState } from "src/app/store/app.reducer";
import { selectNotificationMaintenance } from "src/app/store/user/user.selector";

@Component({
	templateUrl: './notification-maintenance.dialog.component.html',
})
export class NotificationMaintenanceDialogComponent implements OnInit, OnDestroy {

	notificationMaintenance?: NotificationMaintenance[];
	notificationMaintenance$: Observable<NotificationMaintenance[]>;
	notificationMaintenanceSub?: Subscription;

	// design
   screenWidth: number;
   DELTA_ERROR_PIXEL = 7;
   MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	initSelectors() : void {
		this.notificationMaintenance$ = this.store.select(selectNotificationMaintenance);
	}

	ngOnInit(): void {
		this.notificationMaintenanceSub = this.notificationMaintenance$
			.subscribe(notificationMaintenance => {
				this.notificationMaintenance = notificationMaintenance;
			}
		);
	}

	closeDialog(): void {
		const notificationIdStorage = localStorage.getItem(LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID);
      const ab = from(this.notificationMaintenance.map(notification=>notification.NotificationId)).pipe(max((a,b) => a-b));
      ab.subscribe(maxId => {
         if (notificationIdStorage) {
				const notificationId = parseInt(notificationIdStorage, 10);
				if (notificationId < maxId){
					 localStorage.setItem(LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID, maxId.toString());
				}
		  	} else {
				localStorage.setItem(LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID, maxId.toString());
		  	}
		  	this.ref.close();
      });
		
	}

	ngOnDestroy(): void {
		this.notificationMaintenanceSub?.unsubscribe();
	}

	// Design
   @HostListener('window:resize', ['$event'])
   onResize() {
      this.screenWidth = window.innerWidth;
   }

	dynamicButtonWidth(): string {
      return this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH
            ? 'w-full'
            : 'w-16rem';
   }
}